<template>
    <div id="signin_wrapper">
        <v-form v-model="secondary_user_valid" ref="secondary_user">                            
            <v-row>
                <v-col>
                    <div v-if="thisUser.id == null && users_for_parent.length && !selectedUser.length && !create_new_user">
                        <v-select 
                            v-model="selectedUser"
                            :items="users_for_parent"
                            label="Select an Existing User"
                            outlined
                            class="mt-6"
                            @change="populateSelectedUser()">
                            <template v-slot:append-item>
                                <v-list-item @click="create_new_user = true">Add a New User</v-list-item>
                            </template>
                        </v-select>
                    </div>

                    <div v-if="thisUser.id != null || users_for_parent.length == 0 || create_new_user || selectedUser.length">
                        <div class="d-block sansation mb-1">First Name</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model="thisUser.newuser_firstname" 
                                solo 
                                :rules="firstnameRules"
                                required>
                            </v-text-field>
                        </div>

                        <div class="d-block sansation mb-1">Last Name</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model="thisUser.newuser_lastname" 
                                solo 
                                :rules="lastnameRules"
                                required>
                            </v-text-field>
                        </div>
                        
                        <div class="d-block sansation mb-1">Email</div>
                        <div class="d-block">
                            <v-text-field 
                                v-model.lazy="thisUser.newuser_email" 
                                solo 
                                :rules="emailRules" 
                                required
                                :disabled="thisUser.id != undefined">
                            </v-text-field>                                    
                        </div>
                    </div>
                </v-col>

                <v-col class="pl-9">
                    <v-checkbox
                        v-for="(permissions, ndx) in userPermissions"
                        :key="ndx"
                        v-model="thisUser.user_permissions"
                        :label="permissions.text"
                        :value="permissions.value"
                        color="primary darken-1"
                        class="ml-6"
                        hide-details>
                    </v-checkbox>

                    <!-- <div class="d-block mt-12 pt-5 ml-6 sansation">Expiration Date</div> -->

                    <div class="d-block mt-12 pt-3 ml-6">
                        <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="computedExpirationFormatted"
                                    label="Expiration Date"
                                    hide-details
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="thisUser.expiration_date"
                                @input="dateMenu = false"
                                @change="userExpires()">
                            </v-date-picker>
                        </v-menu>

                        <div class="d-flex justify-end">
                            <div class="d-inline mr-3 mt-5">Never Expires</div>
                            <v-checkbox
                                v-model="thisUser.never_expires"
                                color="primary darken-1"
                                class="d-inline mr-n2"
                                @click="neverExpires()"
                                hide-details>
                            </v-checkbox>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-divider></v-divider> 
            <v-row>
                <v-col class="d-flex justify-end">
                    <v-btn 
                        color="primary darken-1" 
                        class="mr-3 d-inline"
                        outlined 
                        id="login_btn" 
                        @click="resetClear" >
                        reset
                    </v-btn>
                    <v-btn 
                        color="primary darken-1" 
                        class="d-inline"
                        dark 
                        id="login_btn" 
                        @click="thisUser.id != undefined ? editSecondaryUser() : createSecondaryUser()" >
                        {{ submit_text }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';

    export default {
        name: 'SecondaryUser',

        props: {
            parentUserId: String,
            project: Object,
            thisUser: Object,
            secondaryUserDialog: Boolean,
            resetCreateNewUser: Boolean,
            refreshUsers: Function,
        },

        data () {
            return {
                alertDialog: false,
                alertMessage: '',
                alertColor: 'error',
                alertDuration: 8000,
                secondary_user_valid: false,
                submit_text: 'Submit',
                firstnameRules: [
                    (v) => !!v || 'First Name is required'
                ],
                lastnameRules: [
                    (v) => !!v || 'Last Name is required'
                ],
                passRules: [
                    (v) => !!v || 'Password is required',
                    (v) => v.length >= 8 || 'Password must be at least 8 charaters long.'
                ],
                emailRules: [
                    (v) => !!v || 'Email is required',
                    (v) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/.test(v) || 'Email must be in valid format'
                ],
        
                userPermissions: [
                    { text: "View All Questionnaire Data", value: "r" },
                    { text: "Edit All Questionnaire Data", value: "w" },
                    { text: "View SRG Provided Deliverables", value: "x" }
                ],
                dateMenu: false,
                create_new_user: false,
                users_for_parent: [],
                selectedUser: []
            }
        },
        
        mounted () {
            this.pullCurrentUsers()
        },

        watch: {
            project(val) {
                this.pullCurrentUsers()
                this.resetClear()
            },
            resetCreateNewUser(val) {
                if ( val ) {
                    this.resetClear()
                }
            }
        },

        computed: {
            computedExpirationFormatted: {
                get: function() {
                    return this.formatDate(this.thisUser.expiration_date)
                },
                set: function(val) {
                    return val;
                }
            },
            ownerIds () {
                return this.project.users.filter( user => user.user_type == 'owner' ).map( user => user.user_id );
            },
            projectOwners () {
                return this.project.users.filter( user => user.user_type == 'owner' )
            },
            projectSecondaryUsers () {
                return this.project.users.filter( user => user.user_type == 'secondary' )
            }
        },

        methods: {
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            formatDateForDB (dateStr) {
                if (!dateStr) return null

                const date = new Date(dateStr).toGMTString();
                const unixTimestamp = Date.parse(date) / 1000;

                return unixTimestamp
            },

            neverExpires: function () {
                this.thisUser.expiration_date = '';
            },

            userExpires: function () {
                this.thisUser.never_expires = false;
            },

            pullCurrentUsers: async function () {
                try {
                    const all_users = await axios.post(`${appUrls.api}/api/users_for_parent`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        ownerIds: this.ownerIds 
                    })

                    if ( all_users.data.outcome ) {
                        let nonreducedSecondaryUsers=[]
                        
                        this.projectOwners.forEach(owner => {
                            all_users.data.users.forEach(usr => {
                                if (usr.parent_user_id === owner.user_id) {
                                    const key = `${usr.first_name} ${usr.last_name}`
                                    nonreducedSecondaryUsers.push({ text: key, value: usr })
                                }
                            })
                        })

                        const currentSecondarys = this.projectSecondaryUsers.map( usr => {
                            return usr.user_id
                        })

                        this.users_for_parent = nonreducedSecondaryUsers.reduce((acc, user) => {
                            const userId = user.value.user_id
                            if ( !acc.ids.has(userId) && !currentSecondarys.includes(userId) ) {
                                acc.ids.add(userId);
                                acc.users.push(user);
                            }
                            return acc;
                        }, { ids: new Set(), users: [] }).users;
                        // console.log(this.users_for_parent)
                    } else {
                        console.log(all_users.data.message)
                    }       
                    
                } catch ( error ) {
                    console.log(error);
                    // this.$emit("addUserFeedback", { outcome: false, message: error });
                }
            },

            populateSelectedUser: function () {
                this.thisUser.user_id = this.selectedUser.user_id
                this.thisUser.newuser_firstname = this.selectedUser.first_name
                this.thisUser.newuser_lastname = this.selectedUser.last_name
                this.thisUser.newuser_email = this.selectedUser.user_email
                this.thisUser.newuser_type = 'secondary'
                this.thisUser.user_permissions = ['r', 'w']
                this.thisUser.expiration_date = ''
                this.thisUser.never_expires = true
                // console.log(this.thisUser)
            },

            createSecondaryUser: async function () {
                try {
                    // this.$refs.secondary_user.validate();
                    if ( this.secondary_user_valid ) {
                        // console.log(this.thisUser)
                        const add_project_user = await axios.post(`${appUrls.api}/api/add_project_user`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: {
                                user_id: this.thisUser.user_id,
                                parentUserId: this.parentUserId,
                                projectId: this.project.project_id,
                                newuser_firstname: this.thisUser.newuser_firstname,
                                newuser_lastname: this.thisUser.newuser_lastname, 
                                newuser_email: this.thisUser.newuser_email,
                                user_permissions: this.thisUser.user_permissions,
                                expiration_date: this.formatDateForDB(this.thisUser.expiration_date+' 00:00:00'), // adding the time helps create the correct unix timestamp
                                never_expires: this.thisUser.never_expires,
                                newuser_type: 'secondary',
                                generate_email: true
                            }
                        })

                        if ( add_project_user.data.outcome ) {
                            await this.pullCurrentUsers()
                            this.$emit('refreshUsers', this.project.project_id, add_project_user.data.message)
                            this.resetClear()
                        } else {
                            console.log(add_project_user.data.message)
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                    // this.$emit("addUserFeedback", { outcome: false, message: error });
                }
            },

            editSecondaryUser: async function () {
                try {
                    // this.$refs.secondary_user.validate();
                    if ( this.secondary_user_valid ) {
                        const edit_project_user = await axios.post(`${appUrls.api}/api/edit_project_user`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: {
                                id: this.thisUser.id,
                                user_id: this.thisUser.user_id,
                                newuser_firstname: this.thisUser.newuser_firstname,
                                newuser_lastname: this.thisUser.newuser_lastname, 
                                user_permissions: this.thisUser.user_permissions,
                                expiration_date: this.formatDateForDB(this.thisUser.expiration_date+' 00:00:00'),
                                never_expires: this.thisUser.never_expires
                            }
                        })
                        
                        if ( edit_project_user.data.outcome ) {
                            await this.pullCurrentUsers()
                            this.$emit('refreshUsers', this.project.project_id, edit_project_user.data.message)
                            this.resetClear()
                        } else {
                            console.log(edit_project_user.data.message)
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },
            
            resetClear () {
                this.thisUser.user_id = null
                this.thisUser.newuser_firstname = ''
                this.thisUser.newuser_lastname = '' 
                this.thisUser.newuser_email = ''
                this.thisUser.user_permissions = ['r','w']
                this.thisUser.expiration_date = ''
                this.thisUser.never_expires = true

                this.create_new_user = false
                this.selectedUser = []
            },

            close () {
                //this.alertDialog = false
                setTimeout(() => {
                    this.alertDialog = false
                }, 5000)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #signin_wrapper {
        width: 100%;
        height: 100%;
    }
    #login {
        min-width: 100%;
        max-width: 100%;
        margin: 2% auto;
        padding: 9%;
        text-align: center;
        font-size: .8rem;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
    }
    #login_btn {
        padding: 4px 20px;
        /* width: 36%; */
        font-size: 1.2em !important;
    }
    .mnt_image {
        background-position: top left; 
        background-repeat: no-repeat; 
        background-attachment: fixed; 
        background-size: cover;
    }
    .return_link {
        font-size: 1.25rem;
        text-decoration: none;
        /* mdi-keyboard-backspace */
    }
    .signin_title {
        /* color: #37383C; */
        font-weight: 600;
        font-size: 1.6rem !important;
        letter-spacing: 0.05rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/SecondaryUser.vue